import './applications.scss';

export default () => {
	let text = document.querySelector( '.js-text-animation' );

	text.innerHTML = text.textContent.trim().replace( /\S/gim, function ( c, i ) {
		return `<span class="char" data-char="${i}" style="--ch:${i}">${c}</span>`;
	} );

	$( window ).scroll( function () {
		if ( $( text ).offset().top - $( this ).innerHeight() / 2 < $( this ).scrollTop() ) {
			if ( !$( text ).hasClass( 'text-animation' ) ) {
				$( text ).addClass( 'text-animation' );
			}
		}
	} );
};
